var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PRIORITY",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.4mm",
    height: "25.4mm",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.72,8.81c-.31-.36-.81-.49-1.26-.33L.79,33.59c-.44.16-.74.57-.76,1.04s.26.9.69,1.09l22.22,9.76v13.3c0,.46.28.88.71,1.06.14.06.29.09.44.09.3,0,.59-.11.81-.33l9.3-9.17,12.33,5.42c.15.07.31.1.46.1.41,0,.81-.23,1.02-.61l23.86-45.23c.22-.42.16-.93-.15-1.29Zm-7.66,4.42l-40.13,30.17-19.65-8.64,59.78-21.54ZM25.23,56.04v-9.54l6.7,2.94-6.7,6.6Zm21.24-2.72l-20.13-8.84,41.09-30.9-20.96,39.74Z",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.9b6ca42908e4a35306cce4c9a62e59a1.svg";
export { ForwardRef as ReactComponent };